import { CnInput as CnInputView } from './cn-input';
import locale from '@/locale';
import { withI18n } from 'panda-i18n';
const CnInput = withI18n(CnInputView, {
    locale,
    componentName: 'CnInput',
    _noHoc: true,
});
export { CnInput };
